import { render } from "./GeneratedCss.vue?vue&type=template&id=37e1ba98"
import script from "./GeneratedCss.vue?vue&type=script&lang=js"
export * from "./GeneratedCss.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__